import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface DisabledOverlayProps {
  children: ReactNode;
}

const DisabledOverlay: React.FC<DisabledOverlayProps> = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 1000,
        backdropFilter: 'blur(3px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        fontSize: '2em',
        fontWeight: 'bold'
      }}
    >
      <Box sx={{ maxWidth: '80vw', textAlign: 'center' }}> {children}</Box>
    </Box>
  );
};

export default React.memo(DisabledOverlay);
